import React, { useState, useEffect } from "react";
import { getAutoAirlines, ManageFrequentFlyer, FrequentFlyerList, DeleteFrequentFlyer } from "../Services/API";


const FrequentFlyer = ({ userName }) => {

    const [AirlinesSuggestions, setAirlinesSuggestions] = useState([]);
    const [flyerList, setFlyerList] = useState([]);

    const [selectedFlyer, setSelectedFlyer] = useState({
        id: 0,
        airlineName: "",
        airlineCode: "",
        frequentFlyerNo: ""
    });

    const [errors, setErrors] = useState({});

    const [flightlist, setFlightlist] = useState({
        id: 0,
        airlineName: "",
        airlineCode: "",
        frequentFlyerNo: ""
    });

    // =========================
    // Airline Search
    // =========================
    const handleAirlineChange = async (e) => {

        const value = e.target.value;

        setFlightlist((prev) => ({
            ...prev,
            airlineName: value,
            airlineCode: ""
        }));

        // Remove error while typing
        setErrors((prev) => ({
            ...prev,
            airlineName: ""
        }));

        // Empty input
        if (!value.trim()) {
            setAirlinesSuggestions([]);
            return;
        }

        try {

            const response = await getAutoAirlines(value);

            //console.log("Airlines:", response);

            setAirlinesSuggestions(response || []);

        } catch (error) {
            //console.log(error);
            setAirlinesSuggestions([]);
        }
    };

    // =========================
    // Select Airline
    // =========================
    const selectAirlines = (airline) => {

        setFlightlist((prev) => ({
            ...prev,
            airlineName: airline.airLineName,
            airlineCode: airline.airLineCode
        }));

        // Clear suggestions
        setAirlinesSuggestions([]);

        // Remove validation error
        setErrors((prev) => ({
            ...prev,
            airlineName: ""
        }));
    };

    // =========================
    // Common Input Change
    // =========================
    const handleFlightChange = (e) => {

        const { name, value } = e.target;

        setFlightlist((prev) => ({
            ...prev,
            [name]: value
        }));

        // Remove validation error
        setErrors((prev) => ({
            ...prev,
            [name]: ""
        }));
    };

    // =========================
    // Validation
    // =========================
    const validateForm = () => {

        let newErrors = {};

        // Airline Validation
        if (!flightlist.airlineName.trim()) {
            newErrors.airlineName = "Please select airline";
        }

        // Airline Code Validation
        if (!flightlist.airlineCode.trim()) {
            newErrors.airlineName = "Please select valid airline";
        }

        // Flyer Number Validation
        if (!flightlist.frequentFlyerNo.trim()) {
            newErrors.frequentFlyerNo =
                "Please enter frequent flyer number";
        }

        setErrors(newErrors);

        return Object.keys(newErrors).length === 0;
    };

    // =========================
    // Submit API
    // =========================
    const AddFlyer = async () => {

        // Validation
        if (!validateForm()) {
            return;
        }

        try {

            // Profile Data
            const profileData =
                JSON.parse(localStorage.getItem("profile")) || {};

            // Email
            const userEmail =
                profileData?.emailId ||
                profileData?.email ||
                "";

            const requestBody = {
                id: 0,
                userName: userName || "",
                airlineName: flightlist.airlineName || "",
                airlineCode: flightlist.airlineCode || "",
                frequentFlyerNo: flightlist.frequentFlyerNo || "",
                actionBy: userName || "",
                messageOut: ""
            };
            //console.log("Request Body:", requestBody);

            const response = await ManageFrequentFlyer(requestBody);

            //console.log("API Response:", response);

            // Already Exists
            if (
                response?.messageOut &&
                (
                    response.messageOut
                        .toLowerCase()
                        .includes("already") ||

                    response.messageOut
                        .toLowerCase()
                        .includes("exist")
                )
            ) {
                alert(response.messageOut);
                return;
            }

            // Success
            alert(
                response?.messageOut ||
                "Frequent Flyer Added Successfully"
            );

            await getFrequentFlyerList();

            // Reload Page
            window.location.reload();

            // Clear Form
            setFlightlist({
                airlineName: "",
                airlineCode: "",
                frequentFlyerNo: ""
            });

            setAirlinesSuggestions([]);
            setErrors({});

        } catch (error) {

            //console.log("Full API Error:", error);

            console.log(
                "Error Response:",
                error?.response
            );

            console.log(
                "Error Data:",
                error?.response?.data
            );

            if (error?.response?.data?.messageOut) {

                alert(error.response.data.messageOut);

            } else if (error?.response?.data?.message) {

                alert(error.response.data.message);

            } else {

                alert("Something went wrong");
            }
        }
    };


    // =========================
    // Get Frequent Flyer List
    // =========================
    const getFrequentFlyerList = async () => {

        try {

            // Pass only userName
            const response = await FrequentFlyerList(
                userName || ""
            );

            console.log(
                "Flyer List Response:",
                response
            );

            // Response Handling
            if (
                response &&
                Array.isArray(response.allFrequentFlyersNo)
            ) {

                setFlyerList(
                    response.allFrequentFlyersNo
                );

            } else {

                setFlyerList([]);
            }

        } catch (error) {

            console.log(
                "Flyer List Error:",
                error
            );

            setFlyerList([]);
        }
    };

    // =========================
    // Page Load
    // =========================
    useEffect(() => {

        if (userName) {
            getFrequentFlyerList();
        }

    }, [userName]);


    const UpdateFlyer = async () => {

        try {

            const requestBody = {

                // Existing ID for Update
                id: selectedFlyer.id,

                userName: userName || "",

                airlineName:
                    selectedFlyer.airlineName || "",

                airlineCode:
                    selectedFlyer.airlineCode || "",

                frequentFlyerNo:
                    selectedFlyer.frequentFlyerNo || "",

                actionBy: userName || "",

                messageOut: ""
            };

            console.log(
                "Update Request:",
                requestBody
            );

            // SAME API
            const response =
                await ManageFrequentFlyer(
                    requestBody
                );

            console.log(
                "Update Response:",
                response
            );

            alert(
                response?.messageOut ||
                "Frequent Flyer Updated Successfully"
            );

            // Refresh List
            await getFrequentFlyerList();
            window.location.reload();
            // Close Modal
            setSelectedFlyer({
                id: 0,
                airlineName: "",
                airlineCode: "",
                frequentFlyerNo: ""
            });

        } catch (error) {

            //console.log(error);

            alert("Failed to update Frequent Flyer");
        }
    };


    const handleDeleteFlyer = async () => {

        try {

            if (!selectedFlyer?.id) {

                alert("Invalid Frequent Flyer");

                return;
            }

            const response = await DeleteFrequentFlyer(
                selectedFlyer.id,
                userName
            );

            console.log(
                "Delete Response:",
                response
            );

            alert(
                response?.messageOut ||
                "Frequent Flyer Deleted Successfully"
            );

            // Refresh List
            await getFrequentFlyerList();
            window.location.reload();
            // Close Modal
            setSelectedFlyer(null);

        } catch (error) {

            //console.log(error);

            alert("Failed to delete Frequent Flyer");
        }
    };

    return (
        <>
            <div className='row'>
                <div className='col-md-8'>
                    <h3 className='headings'>Frequent Flyer</h3>
                </div>
                <div className='col-md-4 text-end'>
                    <button className="btn btn-primary" data-bs-toggle="modal" data-bs-target="#FlyerUpdateModal"><i className="fa fa-plus"></i>Add</button>
                </div>
                <div class="col-md-12">
                    <table className="table table-bordered">

                        <thead>
                            <tr>
                                <th>Airline Name</th>
                                <th>Airline Code</th>
                                <th>Frequent Flyer Number</th>
                                <th width="120">Action</th>
                            </tr>
                        </thead>

                        <tbody>

                            {flyerList?.length > 0 ? (

                                flyerList.map((item) => (

                                    <tr key={item.id}>

                                        <td>
                                            {item.airlineName || "-"}
                                        </td>

                                        <td>
                                            {item.airlineCode || "-"}
                                        </td>

                                        <td>
                                            {item.frequentFlyerNo || "-"}
                                        </td>

                                        <td>

                                            {/* Edit */}
                                            <span
                                                className="edit_upd me-3"
                                                data-bs-toggle="modal"
                                                data-bs-target="#FlyerEditModal"
                                                onClick={() => {

                                                    setSelectedFlyer({
                                                        id: item.id,
                                                        airlineName: item.airlineName,
                                                        airlineCode: item.airlineCode,
                                                        frequentFlyerNo: item.frequentFlyerNo
                                                    });

                                                }}
                                                style={{ cursor: "pointer" }}
                                            >
                                                <i className="fa fa-edit text-primary"></i>
                                            </span>
                                            {/* Delete */}
                                            <span
                                                className="edit_upd"
                                                data-bs-toggle="modal"
                                                data-bs-target="#FlyerDeleteModal"
                                                onClick={() => setSelectedFlyer(item)}
                                                style={{ cursor: "pointer" }}
                                            >
                                                <i className="fa fa-trash text-danger"></i>
                                            </span>


                                        </td>

                                    </tr>
                                ))

                            ) : (

                                <tr>
                                    <td
                                        colSpan="4"
                                        className="text-center"
                                    >
                                        No Frequent Flyer Found
                                    </td>
                                </tr>
                            )}

                        </tbody>

                    </table>

                </div>

            </div>
            <div class="modal fade" id="FlyerUpdateModal">
                <div class="modal-dialog modal-lg">
                    <div class="modal-content">
                        <div class="modal-header">
                            <h4 class="modal-title">Update Frequent Flyer</h4>
                            <button type="button" class="btn-close" data-bs-dismiss="modal"></button>
                        </div>
                        <div class="modal-body">
                            <div className='row'>
                                <div className="col-md-5 mb-3">
                                    <label className="required">
                                        Airline
                                    </label>

                                    <div className="input_fm_Auto">
                                        <input
                                            type="text"
                                            className={`form-control ${errors.airlineName ? "is-invalid" : ""
                                                }`}
                                            name="airlineName"
                                            placeholder="Airlines.."
                                            value={flightlist.airlineName}
                                            onChange={handleAirlineChange}
                                            autoComplete="off"
                                        />

                                        {errors.airlineName && (
                                            <div className="invalid-feedback">
                                                {errors.airlineName}
                                            </div>
                                        )}

                                        {AirlinesSuggestions.length > 0 && (
                                            <ul className="suggestion-list">
                                                {AirlinesSuggestions.map((airline) => (
                                                    <li
                                                        key={airline.airLineCode}
                                                        onMouseDown={() =>
                                                            selectAirlines(airline)
                                                        }
                                                    >
                                                        {airline.airLineName}
                                                    </li>
                                                ))}
                                            </ul>
                                        )}
                                    </div>
                                </div>

                                {/* Frequent Flyer Number */}
                                <div className="col-md-5 mb-3">
                                    <label className="required">
                                        Frequent Flyer Number
                                    </label>

                                    <input
                                        type="text"
                                        className={`form-control ${errors.frequentFlyerNo ? "is-invalid" : ""
                                            }`}
                                        name="frequentFlyerNo"
                                        placeholder="Enter Flyer Number"
                                        value={flightlist.frequentFlyerNo}
                                        onChange={handleFlightChange}
                                    />

                                    {errors.frequentFlyerNo && (
                                        <div className="invalid-feedback">
                                            {errors.frequentFlyerNo}
                                        </div>
                                    )}
                                </div>

                                {/* Submit */}
                                <div className="col-md-2 mt-8 mb-3 text-end">
                                    <button
                                        className="btn btn-primary"
                                        onClick={AddFlyer}
                                    >
                                        Submit
                                    </button>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>

            <div class="modal fade" id="FlyerEditModal">
                <div class="modal-dialog modal-lg">
                    <div class="modal-content">
                        <div class="modal-header">
                            <h4 class="modal-title">Frequent Flyer Details</h4>
                            <button type="button" class="btn-close" data-bs-dismiss="modal"></button>
                        </div>
                        <div class="modal-body">
                            <div className="row">

                                {/* Airline */}
                                <div className="col-md-5 mb-3">

                                    <label className="required">
                                        Airline
                                    </label>

                                    <div className="input_fm_Auto">

                                        <input
                                            type="text"
                                            className={`form-control ${errors.airlineName
                                                ? "is-invalid"
                                                : ""
                                                }`}
                                            name="airlineName"
                                            placeholder="Airlines.."
                                            value={selectedFlyer.airlineName}
                                            onChange={(e) => {

                                                handleAirlineChange(e);

                                                setSelectedFlyer((prev) => ({
                                                    ...prev,
                                                    airlineName: e.target.value
                                                }));
                                            }}
                                            autoComplete="off"
                                        />

                                        {errors.airlineName && (
                                            <div className="invalid-feedback">
                                                {errors.airlineName}
                                            </div>
                                        )}

                                        {AirlinesSuggestions.length > 0 && (

                                            <ul className="suggestion-list">

                                                {AirlinesSuggestions.map((airline) => (

                                                    <li
                                                        key={airline.airLineCode}
                                                        onMouseDown={() => {

                                                            setSelectedFlyer((prev) => ({
                                                                ...prev,
                                                                airlineName:
                                                                    airline.airLineName,
                                                                airlineCode:
                                                                    airline.airLineCode
                                                            }));

                                                            setAirlinesSuggestions([]);
                                                        }}
                                                    >
                                                        {airline.airLineName}
                                                    </li>

                                                ))}

                                            </ul>
                                        )}

                                    </div>

                                </div>

                                {/* Frequent Flyer Number */}
                                <div className="col-md-5 mb-3">

                                    <label className="required">
                                        Frequent Flyer Number
                                    </label>

                                    <input
                                        type="text"
                                        className={`form-control ${errors.frequentFlyerNo
                                            ? "is-invalid"
                                            : ""
                                            }`}
                                        name="frequentFlyerNo"
                                        placeholder="Enter Flyer Number"
                                        value={selectedFlyer.frequentFlyerNo}
                                        onChange={(e) => {

                                            setSelectedFlyer((prev) => ({
                                                ...prev,
                                                frequentFlyerNo:
                                                    e.target.value
                                            }));
                                        }}
                                    />

                                    {errors.frequentFlyerNo && (
                                        <div className="invalid-feedback">
                                            {errors.frequentFlyerNo}
                                        </div>
                                    )}

                                </div>

                                {/* Update */}
                                <div className="col-md-2 mt-8 mb-3 text-end">

                                    <button
                                        className="btn btn-primary"
                                        onClick={UpdateFlyer}
                                    >
                                        Update
                                    </button>

                                </div>

                            </div>

                        </div>
                    </div>
                </div>
            </div>

            <div class="modal fade" id="FlyerDeleteModal">
                <div class="modal-dialog modal-lg">
                    <div class="modal-content">
                        <div class="modal-header">
                            <h4 class="modal-title">Frequent Flyer Details</h4>
                            <button type="button" class="btn-close" data-bs-dismiss="modal"></button>
                        </div>
                        <div class="modal-body">
                            <div className="row">
                                <div className="col-md-6 mb-3">
                                    <label>Airline</label>
                                    <div className="disply">
                                        {selectedFlyer?.airlineName || "-"}
                                    </div>
                                </div>

                                <div className="col-md-6 mb-3">
                                    <label>Frequent Flyer Number</label>
                                    <div className="disply">
                                        {selectedFlyer?.frequentFlyerNo || "-"}
                                    </div>
                                </div>
                                <div className="col-md-12 text-center mt-5">
                                    <h5 className="text-danger">
                                        Are you sure you want to delete this Frequent Flyer?
                                    </h5>
                                </div>
                                <div className="col-md-12 mt-1 mb-3 text-end">

                                    <button
                                        className="btn btn-danger m-2"
                                        onClick={handleDeleteFlyer}
                                    >
                                        Yes Delete
                                    </button>

                                </div>

                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </>
    )
};

export default FrequentFlyer;